import React, { useState, useEffect } from "react";
import { CaretRightOutlined, RightOutlined } from "@ant-design/icons";
import {
    Collapse,
    Row,
    Col,
    Button,
    Form,
    Input,
    Select,
    DatePicker,
    notification,
    Spin,
    Modal,
    Card,
    Avatar,
    Typography,
    Space, Table
} from "antd";
import { DownloadOutlined, StopOutlined, PrinterOutlined, DeleteOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import TimeSlotEnrollment from "./TimeSlotEnrollment";
import ProgrammeService from "../../api/programme.service";
import CustomTableSearch from "../common/CustomTableSearch";
import timeSlotService from "../../api/time.slot.service";
import commonUtility from "../../utility/Utils";
import StudentCardInfo from "../common/StudentCardInfo";
import {
    DATE_FORMAT_DMY_SLASH,
    HIGH_PERFORMANCE_TAG,
    SUCCESS_STATUS,
} from "../../utility/Constants";
import moment from "moment";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const { Text, Link } = Typography;

const { Panel } = Collapse;
const { Option } = Select;
const { confirm } = Modal;

const defaultFormValues = {
    mode: "ADD",
    enrollment_id: 0,
    old_enrollment_id: 0,
    member_id: 0,
    programme_id: 0,
    voucher_id: 0,
    date_of_join: null,
    enrollment_start_date: null,
    enrollment_end_date: null,
    last_paid_month: "",
    programme_group_id: 0,
    member_status: "Y",
    day_slot: [],
};

let styles = {
    studentInfoCard: {
        border: '0px'
    },
    studentPersonalInfo: {
        textAlign: 'left',
        backgroundColor: 'rgb(204, 247, 138)',
        padding: '10px 20px',
        borderTopLeftRadius: '10px',
        borderBottomLeftRadius: '10px',
        borderRight: '3px solid #fff'
    },

}


const ProgramTransfer = () => {
    const [form] = Form.useForm();
    const [fromProgramme, setFromProgramme] = useState(null);
    const [memberList, setMemberList] = useState([]);

    const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
    const [page, setPage] = React.useState(1);


    const [formProgrammeId, setFormProgrammeId] = useState("");
    const [toProgrammeId, setToProgrammeId] = useState("");
    const [filteredSearchList, setFilteredSearchList] = useState([]);

    const columns = [
        {
            title: '#',
            dataIndex: 'index',
            render: (text, record, index) => (page - 1) * 10 + ++index,
            width: '5%',
        },
        {
            title: 'Name',
            dataIndex: 'member',
            key: 'member',
        },
        {
            title: 'From Programme',
            dataIndex: 'from_programme',
            key: 'from_programme',
            render: (text) => <span style={{ color: 'red', fontWeight: "bold" }}>{text}</span>,
        },
        {
            title: 'Group',
            dataIndex: 'from_group',
            key: 'from_group',
        },
        {
            title: 'Status',
            dataIndex: 'enrolled_from',
            key: 'enrolled_from',
        },
        {
            title: 'To Programme',
            dataIndex: 'to_programme',
            key: 'to_programme',
            render: (text) => <span style={{ color: 'green', fontWeight: "bold" }}>{text}</span>,
        },
        {
            title: 'Group',
            dataIndex: 'to_group',
            key: 'to_group',
        },
        {
            title: 'New Prog. Date',
            dataIndex: 'new_program_start_date',
            key: 'new_program_start_date',
        },
        {
            title: 'Transfer Date',
            dataIndex: 'date_of_transfer',
            key: 'date_of_transfer',
        },
    ];


    const handleSubmit = async () => {

        const formdata = {
            formdata: {
                fromProgrammeId: formProgrammeId,
                toProgrammeId: toProgrammeId
            }
        }

        const response = await ProgrammeService.getProgrammeTransferList(formdata);
        console.log("response", response);
        console.log("response_data", response.data.response_status);
        if (response.data.response_status === "SUCCESS") {
            setMemberList(response.data.response_data);
            setFilteredSearchList(response.data.response_data);
            console.log("memberList", memberList);

        } else {
            notification.error({
                message: "Error",
                description: "Error fetching member data. Please try again later.",
            });
        }
    }

    const onSearch = (e) => {
        setFilteredSearchList([]);
        const string = e.target.value;
        const x = memberList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
        setFilteredSearchList(x)
    }

    const exportToExcel = async () => {
        if (!filteredSearchList.length) {
            notification.error({
                message: "Error",
                description: "No data to export",
            });
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Transfers");

        // Define columns
        const columns = [
            { header: "#", key: "index", width: 10 },
            { header: "Name", key: "member" },
            { header: "From Programme", key: "from_programme" },
            { header: "Group", key: "from_group" },
            { header: "Status", key: "enrolled_from" },
            { header: "To Programme", key: "to_programme" },
            { header: "To Group", key: "to_group" },
            { header: "New Prog. Date", key: "new_program_start_date" },
            { header: "Transfer Date", key: "date_of_transfer" },
        ];

        worksheet.columns = columns.map(col => ({ ...col, width: col.header.length + 2 }));

        // Merge first row (A1 to last column) and add title
        const lastColumnLetter = String.fromCharCode(65 + columns.length - 1); // Get last column letter
        worksheet.mergeCells(`A1:${lastColumnLetter}1`);
        const titleCell = worksheet.getCell("A1");
        titleCell.value = "Transfer List";
        titleCell.font = { bold: true, size: 14, color: { argb: "1a8811" } };
        titleCell.alignment = { horizontal: "center", vertical: "middle" };
        titleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } };

        // Move headers to the second row
        worksheet.addRow(columns.map(col => col.header));

        // Style Header Row (Row 2)
        const headerRow = worksheet.getRow(2);
        headerRow.eachCell(cell => {
            cell.font = { bold: true, color: { argb: "FFFFFF" } };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "1a8811" } };
            cell.alignment = { horizontal: "center" };
        });

        // Add data rows
        filteredSearchList.forEach((item, index) => {
            worksheet.addRow({
                index: (page - 1) * 10 + (index + 1),
                member: item.member || "",
                from_programme: item.from_programme || "",
                from_group: item.from_group || "",
                enrolled_from: item.enrolled_from || "",
                to_programme: item.to_programme || "",
                to_group: item.to_group || "",
                new_program_start_date: item.new_program_start_date || "",
                date_of_transfer: item.date_of_transfer || "",
            });
        });

        // Adjust column width dynamically
        worksheet.columns.forEach(column => {
            let maxLength = column.header.length;
            column.eachCell({ includeEmpty: true }, cell => {
                if (cell.value) {
                    const cellValue = cell.value.toString().trim();
                    maxLength = Math.max(maxLength, cellValue.length);
                }
            });
            column.width = maxLength + 3;
        });

        // Generate file and trigger download
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        saveAs(blob, `transfer_list.xlsx`);
    };



    return (
        <div className="form-input-style">
            <Row
                className="login-first-step-row"
                style={{ background: "transparent" }}
            >
                <Col
                    className="form-format-type1 enrollment-form jcp-enrollment"
                    xs={24}
                    xl={24}
                >
                    <Form
                        form={form}
                        layout="vertical"
                        autoComplete="off"
                        initialValues={defaultFormValues}
                        onFinish={handleSubmit}
                    >
                        <Collapse
                            bordered={false}
                            defaultActiveKey={["programme_jcp", "schedule_jcp"]}
                            expandIcon={({ isActive }) => (
                                <CaretRightOutlined rotate={isActive ? 90 : 0} />
                            )}
                        >
                            <Panel
                                header={<h4>Programme</h4>}
                                key="programme_jcp"
                                className="mainPanel"
                            >
                                <Row gutter={20}>
                                    <Col xs={24} xl={12}>
                                        <Row gutter={20}>
                                            <Col className="gutter-row" xs={24} xl={8}>
                                                <Form.Item
                                                    label="From Programme"
                                                    name="fromProgramme"
                                                    rules={[
                                                        { required: true, message: "Select Programme" },
                                                    ]}
                                                >
                                                    <Select
                                                        showSearch
                                                        placeholder="Select Programme"
                                                        onChange={(value) => setFormProgrammeId(value)}
                                                    >
                                                        <Option value="3">JCP</Option>
                                                        <Option value="1">HP</Option>
                                                        <Option value="6">JHP</Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>

                                            <Col className="gutter-row" xs={24} xl={8}>
                                                <Form.Item
                                                    label="To Programme"
                                                    name="toProgramme"

                                                    rules={[
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                if (
                                                                    !value ||
                                                                    getFieldValue("fromProgramme") !== value
                                                                ) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(
                                                                    new Error(
                                                                        "Cannot select the same Programme as From"
                                                                    )
                                                                );
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <Select showSearch placeholder="Select Programme" onChange={(value) => setToProgrammeId(value)}>
                                                        <Option
                                                            value="3"
                                                            disabled={formProgrammeId == "3"}

                                                        >
                                                            JCP
                                                        </Option>
                                                        <Option
                                                            value="1"
                                                            disabled={formProgrammeId == "1"}
                                                        >
                                                            HP
                                                        </Option>
                                                        <Option
                                                            value="6"
                                                            disabled={formProgrammeId == "6"}
                                                        >
                                                            JHP
                                                        </Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" xs={24} xl={8} style={{ marginTop: "23px" }}><Button type="primary" htmlType="submit">Search</Button></Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <div className='tableView' style={{ background: '#f9f9f9' }}>
                                    <Row gutter={10}>
                                        <Col xs={24} xl={2}>
                                            <Button htmlType="button" style={{ marginLeft: "10px", marginTop: "10px", color: "white", backgroundColor: "green" }} onClick={exportToExcel}  >
                                                Excel <DownloadOutlined />
                                            </Button>
                                        </Col>
                                        <Col xs={24} xl={22}>
                                            <CustomTableSearch onSearchTable={onSearch} style={{ marginBottom: "8px" }} />
                                        </Col>
                                    </Row>
                                    <div className="form-content">
                                        <Table
                                            rowKey="member_id"
                                            className="nestedTable"
                                            size="small"
                                            columns={columns}
                                            dataSource={filteredSearchList} pagination={{
                                                showTotal,
                                                onChange(current) {
                                                    setPage(current);
                                                }
                                            }}
                                            style={{ marginTop: "23px" }}
                                        />
                                    </div>
                                </div>
                            </Panel>
                        </Collapse>
                    </Form>
                </Col>
            </Row>
        </div>
    );
};

export default ProgramTransfer;
